export default __webpack_public_path__ + "media/images/home-app-illustration-e202cc6b.png";